import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import * as React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { I18nProvider } from './lib/i18n'
import { trpc, trpcClientForReact } from './lib/trpc'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false, // 完全禁用重试
      refetchOnWindowFocus: false, // 窗口获得焦点时不重新获取
      refetchOnReconnect: true, // 网络重新连接时重新获取
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <trpc.Provider client={trpcClientForReact} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <I18nProvider>
          <App />
        </I18nProvider>
      </QueryClientProvider>
    </trpc.Provider>
  </React.StrictMode>,
)
